import { Currency, Locale } from '../i18n'

export interface MoneyHook {
  formatMoney: (input?: string | null) => string
  isZeroAmount: (amount: any) => boolean
}
export interface MoneyConfig {
  currency?: Currency
  locale?: Locale | 'default'
  decimalPlaces?: number
  currencyDisplay?: 'symbol' | 'narrowSymbol' | 'code' | 'name'
}

export const useMoney = ({ currency = 'AUD' as Currency, locale = 'default', decimalPlaces, currencyDisplay = 'symbol' }: MoneyConfig): MoneyHook => {
  const formattingOptions: Intl.NumberFormatOptions = {
    style: 'currency',
    currencyDisplay, // Safari does not support narrowSymbol
    ...(typeof decimalPlaces !== 'undefined' && {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    }),
    currency,
  }
  const formatter = new Intl.NumberFormat(locale, formattingOptions)

  const formatMoney = (input?: string | null): string => {
    const numericAmount = typeof input === 'undefined' ? 0 : Number(input) ?? 0
    return formatter.format(numericAmount)
  }

  const isZeroAmount = (amount: any): boolean => {
    if (typeof amount !== 'string' && typeof amount !== 'number') {
      return false
    }

    if (typeof amount === 'string' && amount.trim() === '') {
      return false
    }

    const numericAmount = Number(amount) ?? -1
    return numericAmount === 0
  }

  return { formatMoney, isZeroAmount }
}
